
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPumpOffHorizontal as ObiPumpOffHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pump-off-horizontal.js';
 
 
 

 
 export const ObiPumpOffHorizontal = createComponent({
   react: React,
   tagName: 'obi-pump-off-horizontal',
   elementClass: ObiPumpOffHorizontalElement,
   events: {
     
   }
  });
 
 